import { connect } from 'react-redux';

import { StoreState } from '../../../../../reducers';
import MediaPreview from '../../../../../components/Editor/EditPanel/SpreadBackgroundPanel/MediaPreview';
import { getResourceUrl, getVideoCover, getClientAndResourceIds } from '../../../utils/helpers';
import { Api } from '../../../../../typings/api';

const mapStateToProps = (state: StoreState, ownProps) => {
	const { galleryInfos } = state;
	const { tempGId: resourceId } = getClientAndResourceIds();
	const { bgMediaData: { relUrl, type } } = ownProps;
	let url = getResourceUrl(relUrl, galleryInfos.config, resourceId);

	if (type === Api.AssetItemFileTypes.MOVIE) {
		url = getVideoCover(url);
	}

	return {
		url,
	};
};

export default connect(mapStateToProps)(MediaPreview);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/SpreadBackgroundPanel/MediaPreview/index.tsx